var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils as dataUtils } from '@easydata/core';
import { Widget, WidgetGroup } from '@easyquery/core';
/**
 * Base class for GRID.
 */
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    /**
     * The default constructor.
     * @param slot The html element.
     */
    function Grid(slot) {
        var _this = _super.call(this, slot) || this;
        _this.options = {
            useCustomLocaleSettings: false
        };
        _this.slot = slot;
        _this.group = WidgetGroup.Result;
        return _this;
    }
    Grid.prototype.getWidgetType = function () {
        return 'grid';
    };
    /**
     * Initialize widget.
     * @param context The context.
     * @param options The options.
     */
    Grid.prototype.init = function (context, options) {
        _super.prototype.init.call(this, context, options);
        if (options) {
            dataUtils.assignDeep(this.options, options);
        }
    };
    /**
     * Refresh widget implementation
     */
    Grid.prototype.refreshCore = function () {
        this.clear();
        if (!this.context.resultTable) {
            return;
        }
        this.render();
    };
    /**
     * Renders widget
     */
    Grid.prototype.render = function () {
        if (this.options.beforeTableRendering) {
            this.options.beforeTableRendering(this.context.resultTable);
        }
        this.applyDisplayFormats();
    };
    Grid.prototype.applyDisplayFormats = function () {
    };
    /**
     * Clears GRID.
     */
    Grid.prototype.clear = function () {
        this.slot.innerHTML = "";
    };
    return Grid;
}(Widget));
export { Grid };
//# sourceMappingURL=grid.js.map